import React from "react";
import ReactDOM from "react-dom";
import Swal from "sweetalert2";

function Confirmation(message, callback) {
    const data = JSON.parse(message);

    const container = document.createElement("div");
    container.setAttribute("custom-confirmation-navigation", "");
    document.body.appendChild(container);

    ReactDOM.render(
        <React.Fragment>
            {Swal.fire({
                title: "Are you sure?",
                text: data.messageText,
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes",
                confirmButtonColor: "#27272F",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.value) {
                    callback(true);
                }
            })}
        </React.Fragment>,
        container
    );
}

export default Confirmation;
